
// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useQuery, useQueryClient } from "@tanstack/react-query";
// import matrix from "../assets/matrix.png";
// import { Bell } from "lucide-react";
// import "../Style/Navbar.css";

// const API_BASE_URL = "https://api.yellowmatrix.co.in";

// const fetchNotificationCount = async () => {
//   const token = localStorage.getItem("token");
//   const res = await fetch(`${API_BASE_URL}/notifications/count`, {
//     headers: { Authorization: `Bearer ${token}` },
//   });
//   if (!res.ok) throw new Error("Failed to fetch count");
//   return res.json();
// };

// const fetchLiveAlerts = async ({ queryKey }) => {
//   const token = localStorage.getItem("token");
//   const [, page] = queryKey;

//   const response = await fetch(
//     `${API_BASE_URL}/live-notifications?page=${page}&per_page=10`,
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     },
//   );

//   if (!response.ok) {
//     throw new Error("Failed to fetch live alerts");
//   }

//   return response.json();
// };

// const Navbar = ({ onSidebarToggle, menuOpen, setMenuOpen }) => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [notificationOpen, setNotificationOpen] = useState(false);
//   const [liveAlertsOpen, setLiveAlertsOpen] = useState(false);
//   const [panelStyle, setPanelStyle] = useState({});
//   const navigate = useNavigate();
//   const [page, setPage] = useState(1);
//   const [liveAlertsPage, setLiveAlertsPage] = useState(1);

//   // 🎯 CHANGE: Track only a single expanded string key. If null, all are collapsed.
//   const [expandedAlertKey, setExpandedAlertKey] = useState(null);
//   const perPage = 10;

//   const bellRef = useRef(null);
//   const queryClient = useQueryClient();

//   const fetchNotifications = async ({ queryKey }) => {
//     const token = localStorage.getItem("token");
//     const [, page] = queryKey;
//     const res = await fetch(
//       `${API_BASE_URL}/notifications?page=${page}&per_page=${perPage}`,
//       { headers: { Authorization: `Bearer ${token}` } },
//     );
//     if (!res.ok) throw new Error("Failed to fetch notifications");
//     return res.json();
//   };

//   const { data } = useQuery({
//     queryKey: ["notifications", page],
//     queryFn: fetchNotifications,
//     refetchInterval: 120000,
//   });

//   const notifications = data?.data || [];

//   const { data: countData } = useQuery({
//     queryKey: ["notificationCount"],
//     queryFn: fetchNotificationCount,
//     refetchInterval: 120000,
//   });

//   const { data: liveAlertsData } = useQuery({
//     queryKey: ["liveAlerts", liveAlertsPage],
//     queryFn: fetchLiveAlerts,
//     refetchInterval: 120000,
//   });

//   // 🎯 CHANGE: Closes the active alert row if clicked again, otherwise expands new row.
//   const toggleAlertMessage = (key) => {
//     setExpandedAlertKey((prevKey) => (prevKey === key ? null : key));
//   };

//   const markAsRead = async (id) => {
//     const token = localStorage.getItem("token");
//     await fetch(`${API_BASE_URL}/notifications/read/${id}`, {
//       method: "PUT",
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     queryClient.invalidateQueries(["notifications"]);
//     queryClient.invalidateQueries(["notificationCount"]);
//   };

//   const alerts = liveAlertsData?.data || [];

//   const calculatePanelStyle = () => {
//     if (bellRef.current) {
//       const rect = bellRef.current.getBoundingClientRect();
//       return {
//         position: "fixed",
//         top: rect.bottom + 8 + "px",
//         right: window.innerWidth - rect.right + "px",
//         left: "auto",
//         width: "300px",
//         maxWidth: "90vw",
//         zIndex: 99999,
//       };
//     }
//     return {
//       position: "fixed",
//       top: "70px",
//       right: "10px",
//       left: "auto",
//       width: "300px",
//       maxWidth: "90vw",
//       zIndex: 99999,
//     };
//   };

//   const toggleNotifications = () => {
//     if (!notificationOpen) {
//       setPanelStyle(calculatePanelStyle());
//     }
//     setLiveAlertsOpen(false);
//     setNotificationOpen((prev) => !prev);
//   };

//   useEffect(() => {
//     if (!notificationOpen) return;
//     const handleResize = () => setPanelStyle(calculatePanelStyle());
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [notificationOpen]);

//   const convertToISTFromString = (timeStr) => {
//     if (!timeStr) return "";
//     const [time, modifier] = timeStr.split(" ");
//     const [hoursStr, minutesStr] = time.split(":");
//     let hours = parseInt(hoursStr, 10);
//     const minutes = parseInt(minutesStr, 10);
//     if (modifier.toUpperCase() === "PM" && hours !== 12) hours += 12;
//     if (modifier.toUpperCase() === "AM" && hours === 12) hours = 0;
//     let totalMinutes = hours * 60 + minutes + 5 * 60 + 30;
//     totalMinutes = totalMinutes % (24 * 60);
//     const istHours = Math.floor(totalMinutes / 60);
//     const istMinutes = totalMinutes % 60;
//     const istAmPm = istHours >= 12 ? "PM" : "AM";
//     const formattedHours = ((istHours + 11) % 12) + 1;
//     const formattedMinutes = istMinutes.toString().padStart(2, "0");
//     return `${formattedHours}:${formattedMinutes} ${istAmPm}`;
//   };

//   const formatTimestamp = (timestamp) => {
//     if (!timestamp) return "No timestamp";
//     return new Date(timestamp).toLocaleString("en-IN", {
//       dateStyle: "medium",
//       timeStyle: "short",
//     });
//   };

//   const getInitials = (name) => {
//     if (!name) return "US";
//     const names = name.split(" ");
//     return names
//       .map((n) => n[0])
//       .join("")
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   const fetchUserData = async () => {
//     const token = localStorage.getItem("token");
//     if (!token) throw new Error("No authentication token found.");
//     const response = await fetch(`${API_BASE_URL}/me`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     if (!response.ok) {
//       if (response.status === 401) {
//         localStorage.removeItem("token");
//         navigate("/login");
//       }
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }
//     const userData = await response.json();
//     return {
//       name: userData.name || userData.Username || "User",
//       email: userData.Email || "",
//       initials: getInitials(userData.name || userData.Username || "User"),
//     };
//   };

//   const {
//     data: user,
//     isLoading,
//     isError,
//     error,
//   } = useQuery({
//     queryKey: ["currentUser"],
//     queryFn: fetchUserData,
//     staleTime: 5 * 60 * 1000,
//     cacheTime: 10 * 60 * 1000,
//     retry: 1,
//     refetchOnWindowFocus: false,
//     refetchOnMount: false,
//   });

//   const toggleAlerts = () => {
//     setNotificationOpen(false);
//     setLiveAlertsOpen((prev) => !prev);
//     // Automatically close any expanded content when panel toggles open/close
//     setExpandedAlertKey(null);
//   };
//   const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     navigate("/login");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownOpen && !event.target.closest(".user-dropdown")) {
//         setDropdownOpen(false);
//       }
//       if (
//         notificationOpen &&
//         !event.target.closest(".notification-container") &&
//         !event.target.closest(".notification-panel-fixed")
//       ) {
//         setNotificationOpen(false);
//       }
//       if (liveAlertsOpen && !event.target.closest(".alerts-container")) {
//         setLiveAlertsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [dropdownOpen, notificationOpen, liveAlertsOpen]);

//   if (isLoading)
//     return (
//       <nav className="navbar">
//         <div className="navbar-loading">Loading user data...</div>
//       </nav>
//     );
//   if (isError)
//     return (
//       <nav className="navbar">
//         <div className="navbar-error">
//           Error: {error?.message || "Unknown error"}
//         </div>
//       </nav>
//     );
//   if (!user)
//     return (
//       <nav className="navbar">
//         <div className="navbar-error">No user data available.</div>
//       </nav>
//     );

//   return (
//     <nav className="navbar">
//       <button className="sidebar-toggle-mobile" onClick={onSidebarToggle}>
//         <i className="fas fa-bars"></i>
//       </button>

//       <div className="brand-logo-container">
//         <Link to="/Dashboard">
//           <h3 className="brand">TrackMaster Hub</h3>
//         </Link>
//         <div className="company-logo">
//           <img src={matrix} alt="Yellow Matrix Logo" />
//           <h2 className="company-name">
//             <a
//               href="https://www.yellowmatrix.in"
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ textDecoration: "none", color: "inherit" }}
//             >
//               Yellow Matrix Private Limited
//             </a>
//           </h2>
//         </div>
//       </div>

//       <button
//         className="mobile-menu-toggle"
//         onClick={() => setMenuOpen(!menuOpen)}
//       >
//         <i className="fas fa-ellipsis-v"></i>
//       </button>

//       <div className="top-nav">
//         <ul className={`top-nav-menu ${menuOpen ? "show" : ""}`}>
//           <li>
//             <Link
//               to="/mobile-apps"
//               className="nav-link"
//               onClick={() => setMenuOpen(false)}
//             >
//               MOBILE APPS
//             </Link>
//           </li>

//           {/* --- Live Alerts Dropdown Box --- */}
//           <li className="alerts-container">
//             <div className="nav-link alerts-icon" onClick={toggleAlerts}>
//               LIVE ALERTS
//               {liveAlertsData?.notification_count > 0 && (
//                 <span className="notification-badge live-alert-badge">
//                   {liveAlertsData.notification_count}
//                 </span>
//               )}
//             </div>
//             {liveAlertsOpen && (
//               <div className="live-alerts-panel-fixed">
//                 <h4 className="live-alerts-title">*Live Alerts</h4>

//                 <ul className="live-alerts-list">
//                   {alerts.map((alert, index) => {
//                     const alertKey = `${alert.vehicleid}-${index}`;

//                     // 🎯 CHANGE: Checks equality against unique scalar identifier string
//                     const isExpanded = expandedAlertKey === alertKey;
//                     const maxLength = 20;

//                     return (
//                       <li
//                         key={alertKey}
//                         className={`live-alerts-item ${alert.severity || "default"}`}
//                       >
//                         <div className="live-alerts-row">
//                           <div className="live-alerts-icon-box">
//                             <i className="fa-solid fa-triangle-exclamation"></i>
//                           </div>

//                           <div className="live-alerts-content">
//                             <span className="live-alert-vehicle">
//                               {alert.vehicleid}
//                             </span>

//                             <div className="live-alert-message">
//                               {isExpanded
//                                 ? alert.message
//                                 : alert.message.length > maxLength
//                                   ? `${alert.message.slice(0, maxLength)}...`
//                                   : alert.message}
//                             </div>

//                             {alert.message.length > maxLength && (
//                               <button
//                                 className="live-alerts-read-more"
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   toggleAlertMessage(alertKey);
//                                 }}
//                               >
//                                 {isExpanded ? "Read Less ▲" : "Read More ▼"}
//                               </button>
//                             )}

//                             <span className="live-alert-time">
//                               {formatTimestamp(alert.timestamp)}
//                             </span>
//                           </div>
//                         </div>
//                       </li>
//                     );
//                   })}
//                 </ul>

//                 <div className="live-alerts-pagination">
//                   <button
//                     onClick={() => setLiveAlertsPage((p) => Math.max(1, p - 1))}
//                     disabled={liveAlertsPage === 1}
//                   >
//                     Prev
//                   </button>

//                   <span>Page {liveAlertsPage}</span>

//                   <button
//                     onClick={() => setLiveAlertsPage((p) => p + 1)}
//                     disabled={liveAlertsPage >= liveAlertsData?.pages}
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>
//             )}
//           </li>

//           <li>
//             <Link
//               to="/slide-show"
//               className="nav-link"
//               onClick={() => setMenuOpen(false)}
//             >
//               SLIDE SHOW
//             </Link>
//           </li>

//           <li className="notification-container">
//             <div
//               ref={bellRef}
//               className="nav-link bell-icon"
//               onClick={toggleNotifications}
//             >
//               <Bell size={20} />
//               {countData?.count > 0 && (
//                 <span className="notification-badge">{countData.count}</span>
//               )}
//             </div>
//           </li>

//           <li className="user-dropdown">
//             <div className="user-icon-container" onClick={toggleDropdown}>
//               <div className="user-avatar-sm">{user.initials}</div>
//               <span className="user-name-sm">{user.name}</span>
//               <i
//                 className={`fas fa-chevron-${dropdownOpen ? "up" : "down"}`}
//               ></i>
//             </div>

//             {dropdownOpen && (
//               <div className="dropdown-content">
//                 <div className="profile-header">
//                   <div className="user-avatar-lg">{user.initials}</div>
//                   <div className="user-info">
//                     <div className="user-name">{user.name}</div>
//                     <div className="user-email">{user.email}</div>
//                   </div>
//                 </div>
//                 <div className="menu-section">
//                   <Link
//                     to="/Account"
//                     className="menu-item"
//                     onClick={() => {
//                       setDropdownOpen(false);
//                       setMenuOpen(false);
//                     }}
//                   >
//                     <i className="fas fa-user-cog"></i>
//                     <span className="menu-item-text">Account Settings</span>
//                   </Link>
//                   <Link
//                     to="/Alerts"
//                     className="menu-item"
//                     onClick={() => {
//                       setDropdownOpen(false);
//                       setMenuOpen(false);
//                     }}
//                   >
//                     <i className="fas fa-bell"></i>
//                     <span className="menu-item-text">Notifications</span>
//                   </Link>
//                 </div>
//                 <div className="divider"></div>
//                 <div className="menu-section">
//                   <button
//                     className="menu-item logout-item"
//                     onClick={handleLogout}
//                   >
//                     <i className="fas fa-sign-out-alt"></i>
//                     <span className="menu-item-text">Log Out</span>
//                   </button>
//                 </div>
//               </div>
//             )}
//           </li>
//         </ul>
//       </div>

//       {notificationOpen && (
//         <div className="notification-panel-fixed" style={panelStyle}>
//           <h4 className="notification-title">*Notifications</h4>
//           <ul className="notification-list">
//             {notifications.map((note) => {
//               const getType = (msg) => {
//                 const text = msg.toLowerCase();
//                 if (text.includes("in")) return "in";
//                 if (text.includes("out")) return "out";
//                 if (text.includes("summary")) return "summary";
//                 return "default";
//               };
//               const type = getType(note.message);

//               return (
//                 <li
//                   key={note.id}
//                   className={`notification-item ${note.is_read ? "read" : "unread"} ${type}`}
//                   onClick={() => markAsRead(note.id)}
//                 >
//                   <div className="notification-row">
//                     <div className="notification-icon">
//                       {type === "summary" && (
//                         <i className="fa-solid fa-cloud-rain summary-icon"></i>
//                       )}
//                       {type === "in" && (
//                         <i className="fa-solid fa-right-to-bracket in-icon"></i>
//                       )}
//                       {type === "out" && (
//                         <i className="fa-solid fa-right-from-bracket out-icon"></i>
//                       )}
//                       {type === "default" && (
//                         <i className="fa-solid fa-bell default-icon"></i>
//                       )}
//                     </div>
//                     <div className="notification-content">
//                       <span className="message">{note.message}</span>
//                       <span className="time">
//                         {convertToISTFromString(note.time)}
//                       </span>
//                     </div>
//                   </div>
//                 </li>
//               );
//             })}
//           </ul>
//           <div className="pagination">
//             <button
//               onClick={() => setPage((p) => Math.max(p - 1, 1))}
//               disabled={page === 1}
//             >
//               Prev
//             </button>
//             <span>Page {page}</span>
//             <button
//               onClick={() => setPage((p) => p + 1)}
//               disabled={page === data?.pages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import matrix from "../assets/matrix.png";
import { Bell } from "lucide-react";
import "../Style/Navbar.css";

const API_BASE_URL = "https://api.yellowmatrix.co.in";

const fetchNotificationCount = async () => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API_BASE_URL}/notifications/count`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to fetch count");
  return res.json();
};

const fetchLiveAlerts = async ({ queryKey }) => {
  const token = localStorage.getItem("token");
  const [, page] = queryKey;

  const response = await fetch(
    `${API_BASE_URL}/live-notifications?page=${page}&per_page=10`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch live alerts");
  }

  return response.json();
};

const Navbar = ({ onSidebarToggle, menuOpen, setMenuOpen }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [liveAlertsOpen, setLiveAlertsOpen] = useState(false);
  const [panelStyle, setPanelStyle] = useState({});
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [liveAlertsPage, setLiveAlertsPage] = useState(1);
  const [expandedAlertKey, setExpandedAlertKey] = useState(null);
  const perPage = 10;

  const bellRef = useRef(null);
  const queryClient = useQueryClient();

  const fetchNotifications = async ({ queryKey }) => {
    const token = localStorage.getItem("token");
    const [, page] = queryKey;
    const res = await fetch(
      `${API_BASE_URL}/notifications?page=${page}&per_page=${perPage}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    if (!res.ok) throw new Error("Failed to fetch notifications");
    return res.json();
  };

  const { data } = useQuery({
    queryKey: ["notifications", page],
    queryFn: fetchNotifications,
    refetchInterval: 120000,
  });

  const notifications = data?.data || [];

  const { data: countData } = useQuery({
    queryKey: ["notificationCount"],
    queryFn: fetchNotificationCount,
    refetchInterval: 120000,
  });

  const { data: liveAlertsData } = useQuery({
    queryKey: ["liveAlerts", liveAlertsPage],
    queryFn: fetchLiveAlerts,
    refetchInterval: 120000,
  });

  const toggleAlertMessage = (key) => {
    setExpandedAlertKey((prevKey) => (prevKey === key ? null : key));
  };

  const markAsRead = async (id) => {
    const token = localStorage.getItem("token");
    await fetch(`${API_BASE_URL}/notifications/read/${id}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });
    queryClient.invalidateQueries(["notifications"]);
    queryClient.invalidateQueries(["notificationCount"]);
  };

  const alerts = liveAlertsData?.data || [];

  const calculatePanelStyle = () => {
    if (bellRef.current) {
      const rect = bellRef.current.getBoundingClientRect();
      return {
        position: "fixed",
        top: rect.bottom + 8 + "px",
        right: window.innerWidth - rect.right + "px",
        left: "auto",
        width: "300px",
        maxWidth: "90vw",
        zIndex: 99999,
      };
    }
    return {
      position: "fixed",
      top: "70px",
      right: "10px",
      left: "auto",
      width: "300px",
      maxWidth: "90vw",
      zIndex: 99999,
    };
  };

  const toggleNotifications = () => {
    if (!notificationOpen) {
      setPanelStyle(calculatePanelStyle());
    }
    setLiveAlertsOpen(false);
    setNotificationOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!notificationOpen) return;
    const handleResize = () => setPanelStyle(calculatePanelStyle());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [notificationOpen]);

  const convertToISTFromString = (timeStr) => {
    if (!timeStr) return "";
    const [time, modifier] = timeStr.split(" ");
    const [hoursStr, minutesStr] = time.split(":");
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    if (modifier.toUpperCase() === "PM" && hours !== 12) hours += 12;
    if (modifier.toUpperCase() === "AM" && hours === 12) hours = 0;
    let totalMinutes = hours * 60 + minutes + 5 * 60 + 30;
    totalMinutes = totalMinutes % (24 * 60);
    const istHours = Math.floor(totalMinutes / 60);
    const istMinutes = totalMinutes % 60;
    const istAmPm = istHours >= 12 ? "PM" : "AM";
    const formattedHours = ((istHours + 11) % 12) + 1;
    const formattedMinutes = istMinutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${istAmPm}`;
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "No timestamp";
    return new Date(timestamp).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const getInitials = (name) => {
    if (!name) return "US";
    const names = name.split(" ");
    return names
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const fetchUserData = async () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("No authentication token found.");

    const response = await fetch(`${API_BASE_URL}/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const userData = await response.json();

    return {
      name: userData.name || userData.Username || "User",
      email: userData.Email || "",
      initials: getInitials(userData.name || userData.Username || "User"),
    };
  };

  const {
    data: user,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["currentUser"],
    queryFn: fetchUserData,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const toggleAlerts = () => {
    setNotificationOpen(false);
    setLiveAlertsOpen((prev) => !prev);
    setExpandedAlertKey(null);
  };

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownOpen && !event.target.closest(".user-dropdown")) {
        setDropdownOpen(false);
      }

      if (
        notificationOpen &&
        !event.target.closest(".notification-container") &&
        !event.target.closest(".notification-panel-fixed")
      ) {
        setNotificationOpen(false);
      }

      if (liveAlertsOpen && !event.target.closest(".alerts-container")) {
        setLiveAlertsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownOpen, notificationOpen, liveAlertsOpen]);

  if (isLoading) {
    return (
      <nav className="navbar">
        <div className="navbar-loading">Loading user data...</div>
      </nav>
    );
  }

  if (isError) {
    return (
      <nav className="navbar">
        <div className="navbar-error">
          Error: {error?.message || "Unknown error"}
        </div>
      </nav>
    );
  }

  if (!user) {
    return (
      <nav className="navbar">
        <div className="navbar-error">No user data available.</div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <button className="sidebar-toggle-mobile" onClick={onSidebarToggle}>
        <i className="fas fa-bars"></i>
      </button>

      <div className="brand-logo-container">
  <Link to="/Dashboard">
    <h3 className="brand">TrackMaster Hub</h3>
  </Link>

  <div className="company-logo">
    <img src={matrix} alt="Yellow Matrix Logo" />
    <h2 className="company-name">
      <a
        href="https://www.yellowmatrix.in"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        Yellow Matrix Private Limited
      </a>
    </h2>
  </div>

  <div className="platform-recharge-status">
    <span className="platform-status-dot"></span>
    <span>Platform Recharged</span>
  </div>
</div>

      <button
        className="mobile-menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>

      <div className="top-nav">
        <ul className={`top-nav-menu ${menuOpen ? "show" : ""}`}>
          <li>
            <Link
              to="/mobile-apps"
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              MOBILE APPS
            </Link>
          </li>

          <li className="alerts-container">
            <div className="nav-link alerts-icon" onClick={toggleAlerts}>
              LIVE ALERTS
              {liveAlertsData?.notification_count > 0 && (
                <span className="notification-badge live-alert-badge">
                  {liveAlertsData.notification_count}
                </span>
              )}
            </div>

            {liveAlertsOpen && (
              <div className="live-alerts-panel-fixed">
                <h4 className="live-alerts-title">*Live Alerts</h4>

                <ul className="live-alerts-list">
                  {alerts.map((alert, index) => {
                    const alertKey = `${alert.vehicleid}-${index}`;
                    const isExpanded = expandedAlertKey === alertKey;
                    const maxLength = 20;

                    return (
                      <li
                        key={alertKey}
                        className={`live-alerts-item ${alert.severity || "default"}`}
                      >
                        <div className="live-alerts-row">
                          <div className="live-alerts-icon-box">
                            <i className="fa-solid fa-triangle-exclamation"></i>
                          </div>

                          <div className="live-alerts-content">
                            <span className="live-alert-vehicle">
                              {alert.vehicleid}
                            </span>

                            <div className="live-alert-message">
                              {isExpanded
                                ? alert.message
                                : alert.message.length > maxLength
                                  ? `${alert.message.slice(0, maxLength)}...`
                                  : alert.message}
                            </div>

                            {alert.message.length > maxLength && (
                              <button
                                className="live-alerts-read-more"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleAlertMessage(alertKey);
                                }}
                              >
                                {isExpanded ? "Read Less ▲" : "Read More ▼"}
                              </button>
                            )}

                            <span className="live-alert-time">
                              {formatTimestamp(alert.timestamp)}
                            </span>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>

                <div className="live-alerts-pagination">
                  <button
                    onClick={() =>
                      setLiveAlertsPage((p) => Math.max(1, p - 1))
                    }
                    disabled={liveAlertsPage === 1}
                  >
                    Prev
                  </button>

                  <span>Page {liveAlertsPage}</span>

                  <button
                    onClick={() => setLiveAlertsPage((p) => p + 1)}
                    disabled={liveAlertsPage >= liveAlertsData?.pages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </li>

          <li>
            <Link
              to="/slide-show"
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              SLIDE SHOW
            </Link>
          </li>

          <li className="notification-container">
            <div
              ref={bellRef}
              className="nav-link bell-icon"
              onClick={toggleNotifications}
            >
              <Bell size={20} />
              {countData?.count > 0 && (
                <span className="notification-badge">{countData.count}</span>
              )}
            </div>
          </li>

          <li className="user-dropdown">
            <div className="user-icon-container" onClick={toggleDropdown}>
              <div className="user-avatar-sm">{user.initials}</div>
              <span className="user-name-sm">{user.name}</span>
              <i
                className={`fas fa-chevron-${dropdownOpen ? "up" : "down"}`}
              ></i>
            </div>

            {dropdownOpen && (
              <div className="dropdown-content">
                <div className="profile-header">
                  <div className="user-avatar-lg">{user.initials}</div>
                  <div className="user-info">
                    <div className="user-name">{user.name}</div>
                    <div className="user-email">{user.email}</div>
                  </div>
                </div>

                <div className="menu-section">
                  <Link
                    to="/Account"
                    className="menu-item"
                    onClick={() => {
                      setDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    <i className="fas fa-user-cog"></i>
                    <span className="menu-item-text">Account Settings</span>
                  </Link>

                  <Link
                    to="/Alerts"
                    className="menu-item"
                    onClick={() => {
                      setDropdownOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    <i className="fas fa-bell"></i>
                    <span className="menu-item-text">Notifications</span>
                  </Link>
                </div>

                <div className="divider"></div>

                <div className="menu-section">
                  <button
                    className="menu-item logout-item"
                    onClick={handleLogout}
                  >
                    <i className="fas fa-sign-out-alt"></i>
                    <span className="menu-item-text">Log Out</span>
                  </button>
                </div>
              </div>
            )}
          </li>
        </ul>
      </div>

      {notificationOpen && (
        <div className="notification-panel-fixed" style={panelStyle}>
          <h4 className="notification-title">*Notifications</h4>

          <ul className="notification-list">
            {notifications.map((note) => {
              const getType = (msg) => {
                const text = msg.toLowerCase();
                if (text.includes("in")) return "in";
                if (text.includes("out")) return "out";
                if (text.includes("summary")) return "summary";
                return "default";
              };

              const type = getType(note.message);

              return (
                <li
                  key={note.id}
                  className={`notification-item ${note.is_read ? "read" : "unread"} ${type}`}
                  onClick={() => markAsRead(note.id)}
                >
                  <div className="notification-row">
                    <div className="notification-icon">
                      {type === "summary" && (
                        <i className="fa-solid fa-cloud-rain summary-icon"></i>
                      )}
                      {type === "in" && (
                        <i className="fa-solid fa-right-to-bracket in-icon"></i>
                      )}
                      {type === "out" && (
                        <i className="fa-solid fa-right-from-bracket out-icon"></i>
                      )}
                      {type === "default" && (
                        <i className="fa-solid fa-bell default-icon"></i>
                      )}
                    </div>

                    <div className="notification-content">
                      <span className="message">{note.message}</span>
                      <span className="time">
                        {convertToISTFromString(note.time)}
                      </span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="pagination">
            <button
              onClick={() => setPage((p) => Math.max(p - 1, 1))}
              disabled={page === 1}
            >
              Prev
            </button>

            <span>Page {page}</span>

            <button
              onClick={() => setPage((p) => p + 1)}
              disabled={page === data?.pages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;